import { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { MediaContentType, fetchMediaContentTypes } from '../../../../api/MediaContentTypeApi';
import sortBy from 'lodash/sortBy';
import ModuleContext from '../../_contexts/ModuleContext';
import useThrowAsyncError from '../../../../hooks/useThrowAsyncError';

type MediaContentTypesContextValue = MediaContentType[] | undefined;

const MediaContentTypesContext = createContext<MediaContentTypesContextValue>(undefined);

export default MediaContentTypesContext;

export function MediaContentTypesContextProvider({ children }: PropsWithChildren) {
  const [mediaContentTypes, setMediaContentTypes] = useState<MediaContentType[]>();

  const { selectedModule } = useContext(ModuleContext);

  const handleError = useThrowAsyncError();

  useEffect(() => {
    if (!selectedModule) return;

    const fetchAndStoreData = async () => {
      try {
        const { data } = await fetchMediaContentTypes({ moduleId: selectedModule.id });

        const sortedData = sortBy(data, ['category', 'name']);

        setMediaContentTypes(sortedData);
      } catch (error) {
        handleError(error);
      }
    };

    fetchAndStoreData();
  }, [handleError, selectedModule]);

  return <MediaContentTypesContext.Provider value={mediaContentTypes}>{children}</MediaContentTypesContext.Provider>;
}
